class FiteCast {
    static Events = {
        IS_AVAILABLE: 'available',
        CAN_SEEK: 'canseek',
        CONNECTED: 'connected',
        DISCONNECTED: 'disconnected',
        STATE_CHANGED: 'statechanged',
        VOLUME_CHANGED: 'volumechange',
        TIME: 'time',
        MUTE: 'mute',
        UNMUTE: 'unmute',
        PLAYING: 'playing',
        PAUSE: 'pause',
        ENDED: 'ended',
        BUFFERING: 'buffering',
        ERROR: 'error'
    }

    constructor(opt = {}) {
        const join_policies = [
            'tab_and_origin_scoped',
            'origin_scoped',
            'page_scoped'];

        if (!opt.joinpolicy || join_policies.indexOf(opt.joinpolicy) === -1){
            opt.joinpolicy = 'tab_and_origin_scoped';
        }

        if (!opt.receiver || opt.receiver === ''){
            opt.receiver = '5A93AA0B';
        }

        this._emiter = document.createComment('fite-cast-bus');
        this._controller = null;
        this._player = null;
        this._castContext = null;

        this.device = 'Chromecast'

        this.receiver = opt.receiver;
        this.joinpolicy = opt.joinpolicy;

        this.available = false;
        this.connected = false;
        this.volumeLevel = 1;

        this.muted = false;
        this.paused = false;

        this.time = 0;
        this.duration = 0;
        this.endTime = 0;

        this.loadSDK();
    }

    loadSDK() {
        if (window.chrome && !window.chrome.cast) {
            var script = document.createElement('script');
            script.src = 'https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1';
            document.head.appendChild(script);
        }

        window['__onGCastApiAvailable'] = function(isAvailable) {
            // console.log('cast availability', isAvailable);
            if (isAvailable) {
                this.init();
            }
            delete window.__onGCastApiAvailable;
        }.bind(this);
    }

    trigger(event, details) {
        // console.log('triggered event', event, 'width data', details);
        this._emiter.dispatchEvent(
            new CustomEvent(event, {
                detail: details
            })
        );

        return this;
    }

    on(event, cb) {
        this._emiter.addEventListener(event, cb)
        return this;
    }

    off(event, cb) {
        this._emiter.removeEventListener(event, cb)
        return this;
    }

    init(){
        // this.available = window.chrome.cast.isAvailable;
        this.trigger(FiteCast.Events.IS_AVAILABLE, {value: this.available});

        this._castContext = window.cast.framework.CastContext.getInstance();
        this._castContext.setOptions({
            receiverApplicationId: this.receiver,
            autoJoinPolicy: this.joinpolicy
        });

        this._castContext.addEventListener(
            window.cast.framework.CastContextEventType.CAST_STATE_CHANGED,
            this._castStateChanged.bind(this)
        )

        this.setupRemotePlayer();
    }

    reload() {
        this.setupRemotePlayer();
    }

    setupRemotePlayer(){
        this._player = new window.cast.framework.RemotePlayer();
        this._controller = new window.cast.framework.RemotePlayerController(this._player);

        this._controller.addEventListener(
            window.cast.framework.RemotePlayerEventType.VOLUME_LEVEL_CHANGED,
            this._volumeLevelChanged.bind(this));

        this._controller.addEventListener(
            window.cast.framework.RemotePlayerEventType.IS_CONNECTED_CHANGED,
            this._isConnectedChanged.bind(this)
        );

        this._controller.addEventListener(
            window.cast.framework.RemotePlayerEventType.PLAYER_STATE_CHANGED,
            this._playerStateChanged.bind(this)
        );

        this._controller.addEventListener(
            window.cast.framework.RemotePlayerEventType.CURRENT_TIME_CHANGED,
            this._currentTimeChanged.bind(this)
        )
    }

    _volumeLevelChanged(e){
        this.volumeLevel = e.value;
        this.trigger(FiteCast.Events.VOLUME_CHANGED, {value: this.volumeLevel});
    }

    _castStateChanged(){
        // console.log('_castStateChanged', e);
        let available = this._castContext.getCastState() !== window.cast.framework.CastState.NO_DEVICES_AVAILABLE;
        if (this._castContext.getCurrentSession()){
            this.device = this._castContext.getCurrentSession().getCastDevice().friendlyName;
        }
        if (this.available !== available){
            this.available = available;
            this.trigger(FiteCast.Events.IS_AVAILABLE, {
                value: available
            });
        }
    }

    _isConnectedChanged(e){
        // console.log('_isConnectedChanged', e);
        this.connected = e.value;
        if (this.connected) {
            let sessionStatus = this._castContext.getCurrentSession().getSessionState();
            const mediaSession = this._castContext.getCurrentSession().getMediaSession();
            if (mediaSession){
                mediaSession.getStatus();
            }
            this.trigger(FiteCast.Events.CONNECTED, {
                state: sessionStatus,
                active: !!mediaSession
            });
        }else{
            this.trigger(FiteCast.Events.DISCONNECTED, {time: this.endTime, rTime: this.time});
        }
    }

    _playerStateChanged(e){
        // console.log('_playerStateChanged', e);
        if (!this.connected){
            return;
        }

        switch (e.value){
            case 'BUFFERING':
                this.trigger(FiteCast.Events.BUFFERING);
                this.trigger(FiteCast.Events.STATE_CHANGED, {
                    value: FiteCast.Events.BUFFERING
                });
                break;
            case 'PLAYING':
                this.paused = false;
                setTimeout(() => {
                    this.trigger(FiteCast.Events.PLAYING);

                })
                this.trigger(FiteCast.Events.STATE_CHANGED, {
                    value: FiteCast.Events.PLAYING
                });
                break;
            case 'PAUSED':
                this.paused = true;
                setTimeout(() => {
                    this.trigger(FiteCast.Events.PAUSE);
                })
                this.trigger(FiteCast.Events.STATE_CHANGED, {
                    value: FiteCast.Events.PAUSE
                });
                break;
            case 'IDLE':
                this.trigger(FiteCast.Events.ENDED);
                this.trigger(FiteCast.Events.STATE_CHANGED, {
                    value: FiteCast.Events.ENDED
                });
                break
        }
    }

    _currentTimeChanged(){
        // console.log('_currentTimeChanged', e);

        if (!this.connected || this._player.isPaused){
            return;
        }

        this.endTime = this.time;
        this.time = this._player.currentTime;
        this.duration = this._player.duration;

        let data = {
            type: 'vod',
            time: this.time,
            duration: this.duration,
            timePretty: this._controller.getFormattedTime(this.time),
            durationPretty: this._controller.getFormattedTime(this.duration),
        };
        let range = {};

        if (this.duration === -1){
            // live or live with dvr
            var session = window.cast.framework.CastContext.getInstance().getCurrentSession().getMediaSession();
            var seekableRange = session.getEstimatedLiveSeekableRange();

            range.start = Math.round(seekableRange.start);
            range.end = Math.round(seekableRange.end);

            data = Object.assign(data, {
                type: 'live',
                progress: this._controller.getSeekPosition(this.time, range.end),
                range: range
            })
        }else{
            data = Object.assign(data, {
                type: 'vod',
                progress: this._controller.getSeekPosition(this.time, this.duration),
            })
        }
        this.trigger(FiteCast.Events.TIME, data);
    }

    contentId() {
        if (this.connected){
            let session = this._castContext.getCurrentSession().getMediaSession();
            if (session){
                return session.media.contentId || '';
            }
        }
        return '';
    }

    cast(contentId, contentUrl, metadata = {}){
        if (!contentUrl){
            return this.trigger(FiteCast.Events.ERROR, 'No media source');
        }

        let mediaInfo = new window.chrome.cast.media.MediaInfo(contentId);
        mediaInfo.contentUrl = contentUrl;
        mediaInfo.metadata = new window.chrome.cast.media.GenericMediaMetadata();

        mediaInfo.metadata.images =   [new window.chrome.cast.Image(metadata.poster)];
        mediaInfo.metadata.title =    metadata.title;
        mediaInfo.metadata.subtitle = metadata.description;

        let request = new window.chrome.cast.media.LoadRequest(mediaInfo);
        if (metadata.time){
            request.currentTime = metadata.time;
        }
        if (metadata.customData){
            mediaInfo.customData = metadata.customData;
        }
        request.autoplay = true;

        return window.cast.framework.CastContext.getInstance().getCurrentSession().loadMedia(request);
    }

    seek(seconds, isPercentage) {
        // if seek(15, true) we assume 15 is percentage instead of seconds
        if (isPercentage) {
            if (this._player.duration === -1){
                seconds = this._controller.getSeekTime(seconds, window.cast.framework.CastContext.getInstance().getCurrentSession().getMediaSession().getEstimatedLiveSeekableRange().end);
            }else{
                seconds = this._controller.getSeekTime(seconds, this._player.duration);
            }
        }
        this._player.currentTime = seconds;
        this._controller.seek();
        return this;
    }

    rewind(seconds){
        this._player.currentTime = this._player.currentTime - seconds;
        this._controller.seek();
        return this;
    }

    volume(float) {
        this._player.volumeLevel = float;
        this._controller.setVolumeLevel();
        return this;
    }

    play() {
        if (this.paused) {
            this._controller.playOrPause();
        }
        return this;
    }

    pause() {
        if (!this.paused) {
            this._controller.playOrPause();
        }
        return this;
    }

    mute() {
        if (!this.muted) {
            this._controller.muteOrUnmute();
        }
        return this;
    }

    unmute() {
        if (this.muted) {
            this._controller.muteOrUnmute();
        }
        return this;
    }

    disconnect() {
        window.cast.framework.CastContext.getInstance().endCurrentSession(true);
        // this._controller.stop();
    }
}

let castInstance = null;

export default function getCast(options) {
    if (!castInstance) {
        castInstance = new FiteCast(options);
    }
    return castInstance
}
